import React from 'react'

import Block from './Block'
import Header from './Header'

const Preview = ({
  file,
  status,
  light,
  headless,
  close,
  back,
  exportConfig,
  exportToSketch
}) => {
  return (
    <div
      className={`gp-preview ${headless ? 'headless' : ''} ${
        light ? 'light' : ''
      }`}
    >
      {!headless && (
        <Header
          file={file}
          back={back}
          close={close}
          exportConfig={exportConfig}
          exportToSketch={exportToSketch}
        />
      )}
      <div className='file-wrapper'>
        <Block file={file} statu={status} light={light} />
      </div>
    </div>
  )
}

export default Preview
